export const isNode =
  Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'

const vitestMode = typeof process !== 'undefined' && process.env && process.env.VITEST_MODE

let isServerMode

if (vitestMode === 'server') {
  isServerMode = true
} else if (vitestMode === 'client') {
  isServerMode = false
} else if (isNode) {
  isServerMode = true
} else {
  isServerMode = false
}

export const isServer = isServerMode
export const isClient = !isServer
